import React from 'react';
import { humanize, titleize, pluralize } from 'inflection';

import EyeIcon from 'buyside/svgs/eye.svg';
import FeaturedIdeasList from 'buyside/components/presentation/Feed/Feature/FeaturedIdeasList/featuredIdeasList';
import Icon from 'buyside/components/presentation/Icon/icon';
import MessageBubbleIcon from 'buyside/svgs/message_bubble.svg';
import PercentIcon from 'buyside/svgs/percent.svg';

import { ActivityFeedFeatureFragment } from 'interfaces/graphql-typings';
import { FeedItemComponentType } from 'interfaces/feed/feedItems';

import styles from './featureStyles.scss';

const icons = {
  most_commented: MessageBubbleIcon,
  most_viewed: EyeIcon,
  top_percentile: PercentIcon
};

const Feature: React.FC<{
  featuredItem: ActivityFeedFeatureFragment;
} & FeedItemComponentType> = ({
  createdAt,
  currentUser,
  featuredItem,
  handleClick
}): React.ReactElement => (
  <div className={styles.featuredItemArea}>
    <div>
      <Icon
        type={icons[featuredItem.feature as keyof typeof icons]}
        style={styles.featuredItemIcon}
      />
    </div>
    <div className={styles.featuredDetailsArea}>
      <div className={styles.featuredHeaderArea}>
        <h4 className={styles.featuredHeader}>
          {titleize(humanize(featuredItem.feature))} {pluralize(featuredItem.featuredType)}
        </h4>
        <div className={styles.featuredHeaderTimestamp}>{createdAt} ago</div>
      </div>
      <FeaturedIdeasList
        featuredIdeas={featuredItem?.featuredIdeas}
        handleClick={handleClick}
        showUserDetails={Boolean(currentUser?.canViewUserDetails)}
      />
    </div>
  </div>
);

export default Feature;
